(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .factory('CronogramaFungicidasService', CronogramaFungicidasService);

  CronogramaFungicidasService.$inject = [
    '$http'
  ];

  // eslint-disable-next-line max-lines-per-function
  function CronogramaFungicidasService($http) {
    const formWarnings = {
      area: {
        rule: (data) => {
          if (!data || !data.gleba || !data.area) {
            return false;
          }
          const glebaArea = _.max([
            data.gleba.areaEmpreendimento,
            data.gleba.areaPlantio
          ]);

          const alert = data.area > (glebaArea || data.gleba.area_total) &&
            'Área atual maior do que área de plantio ou empreendimento do talhão.';
          return alert;
        },
        text: ''
      }
    };

    const service = {
      loadSchedules,
      createNew,
      willNotPerform,
      loadAplicacao,
      willPerform,
      saveAplicacao,
      deleteSchedule,
      loadSchedule,
      createAplicacao,
      duplicateSchedule,
      updateSchedule,
      checkFormWarnings,
      setGlebaAreaEmpreendimento,
      aplicacoesNaoVinculadas
    };
    return service;

    function checkFormWarnings(data) {
      for (const key in formWarnings) {
        const warning = formWarnings[key];
        warning.text = warning.rule(data);
      }

      return formWarnings;
    }

    function setGlebaAreaEmpreendimento(gleba, empreendimentos) {
      if (gleba) {
        const areaEmpreendimento = empreendimentos.reduce((accum, empreendimento) => {
          const empreendimentosGleba = empreendimento.empreendimento_glebas
            .filter(({ cd_gleba: cdGleba }) => (cdGleba === gleba.id));

          const area = _.sumBy(empreendimentosGleba, (empreendimentoGleba) => +empreendimentoGleba.area);
          return accum + area;
        }, 0);

        gleba.areaEmpreendimento = areaEmpreendimento;
      }
    }

    function loadSchedules({
      propriedade = null,
      safra = null,
      atividade = null,
      gleba = null
    }) {
      return $http.get(`${SERVER}v1/cronogramas_fungicidas`, {
        params: { propriedade, safra, atividade, gleba }
      }).then(({ data }) => data.map((cronograma) => {
        cronograma.parameters = cronograma.parameters.map((aplicacao) => {
          aplicacao.extraInfo = getAplicacaoInfo(aplicacao);
          return aplicacao;
        });
        return cronograma;
      }));
    }

    function createNew(cronograma) {
      const data = {
        quantidade_aplicacoes: cronograma.quantidade,
        data_primeira_aplicacao: cronograma.first,
        cronograma_fungicida: {
          atividade_id: cronograma.atividade.id,
          cultivar_id: cronograma.cultivar.item_id,
          gleba_id: cronograma.gleba.id,
          safra_id: cronograma.safra.id,
          data_plantio: cronograma.plantio,
          data_emergencia: cronograma.emergencia,
          ciclo_dias: cronograma.ciclo,
          dias_intervalo: cronograma.intervalo,
          area: cronograma.area,
          data_estimada_colheita: cronograma.colheitaEstimada
        }
      };
      return $http.post(`${SERVER}v1/cronogramas_fungicidas`, data);
    }

    function willNotPerform(aplicacao) {
      const data = {
        cronograma_fungicida_parameter: {
          st_sera_realizada: 'N'
        }
      };

      return $http.patch(`${SERVER}v1/cronograma_fungicida_parameters/${aplicacao.id}`, data);
    }

    function willPerform(aplicacao) {
      const data = {
        cronograma_fungicida_parameter: {
          st_sera_realizada: 'S'
        }
      };

      return $http.patch(`${SERVER}v1/cronograma_fungicida_parameters/${aplicacao.id}`, data);
    }

    function loadAplicacao(aplicacao) {
      return $http.get(`${SERVER}v1/cronograma_fungicida_parameters/${aplicacao}`)
        .then(({ data }) => {
          data.extraInfo = getAplicacaoInfo(data);
          return data;
        });
    }

    function saveAplicacao(id, newData) {
      const items = newData.items_attributes.map((item) => ({
        dose: item.dose,
        item_id: item.item_id,
        item_tipo: item.item_tipo,
        unidade_nome_sistema: item.unidade_nome_sistema
      }));

      return $http.patch(`${SERVER}v1/cronograma_fungicida_parameters/${id}`, {
        cronograma_fungicida_parameter: {
          ...newData, items_attributes: items
        }
      });
    }

    function createAplicacao(cronograma, newData) {
      const items = newData.items_attributes.map((item) => ({
        dose: item.dose,
        item_id: item.item_id,
        item_tipo: item.item_tipo,
        unidade_nome_sistema: item.unidade_nome_sistema
      }));

      return $http.post(`${SERVER}v1/cronograma_fungicida_parameters`, {
        cronograma_fungicida_parameter: {
          ...newData, items_attributes: items
        },
        cronograma_fungicida_id: cronograma
      });
    }

    function deleteSchedule({ id }) {
      return $http.delete(`${SERVER}v1/cronogramas_fungicidas/${id}`);
    }

    function loadSchedule(schedule) {
      return $http.get(`${SERVER}v1/cronogramas_fungicidas/${schedule}`)
        .then(({ data }) => {
          data.parameters = data.parameters.map((aplicacao) => {
            aplicacao.extraInfo = getAplicacaoInfo(aplicacao);
            return aplicacao;
          });
          return data;
        });
    }

    function updateSchedule(id, cronograma) {
      const data = {
        cronograma_fungicida: {
          data_plantio: cronograma.plantio,
          ciclo_dias: cronograma.ciclo,
          data_emergencia: cronograma.emergencia,
          cultivar_id: cronograma.cultivar.item_id,
          area: cronograma.area,
          ordem: cronograma.ordem,
          data_estimada_colheita: cronograma.colheitaEstimada
        }
      };

      return $http.patch(`${SERVER}v1/cronogramas_fungicidas/${id}`, data);
    }

    function duplicateSchedule(schedule, glebas = []) {
      return $http.post(`${SERVER}v1/cronogramas_fungicidas/${schedule}/duplicate`, {
        gleba_ids: glebas
      });
    }

    function getAplicacaoInfo({ status }) {
      const aplicacaoInfo = { icon: '', title: '', color: '', border: '' };

      if (status === 'will_not_perform') {
        aplicacaoInfo.icon = 'fa-times';
        aplicacaoInfo.title = 'Não será aplicada';
        aplicacaoInfo.color = 'text-muted';
      } else if (status === 'applied') {
        aplicacaoInfo.icon = 'fa-check';
        aplicacaoInfo.title = 'Aplicada';
        aplicacaoInfo.color = 'text-equilibrio';
        aplicacaoInfo.border = 'border-equilibrio';
      } else if (status === 'delayed') {
        aplicacaoInfo.icon = 'fa-clock-o';
        aplicacaoInfo.title = 'Atrasada';
        aplicacaoInfo.color = 'text-emergencia';
        aplicacaoInfo.border = 'border-emergencia';
      } else if (status === 'pending') {
        aplicacaoInfo.icon = 'fa-calendar';
        aplicacaoInfo.title = 'Pendente';
        aplicacaoInfo.color = 'text-controle';
        aplicacaoInfo.border = 'border-controle';
      } else if (status === 'in_progress') {
        aplicacaoInfo.icon = 'fa-spinner';
        aplicacaoInfo.title = 'Em andamento';
        aplicacaoInfo.color = 'text-equilibrio';
        aplicacaoInfo.border = 'border-equilibrio';
      }

      return aplicacaoInfo;
    }

    function aplicacoesNaoVinculadas({
      safra = null,
      atividade = null,
      gleba = null,
      operacao = null
    }) {
      return $http.get(`${SERVER}v1/cronogramas_fungicidas/aplicacoes_nao_vinculadas`, {
        params: { safra, atividade, gleba, operacao }
      });
    }
  }
}());
